export default __webpack_public_path__ + "static/media/V250MANB3.9242a2b6.pdf";